export const WorkExperience = [
  {
    companyName: 'Airbus',
    timeLine: "Oct-2023 to Present",
    designations: ["Software Engineer"],
    description: [
      "Developing end to end software solution using angular, node.js, MySQL & AWS services.",
      "Migration of legacy system to newer technology that runs 10x time faster than old system.",
      "Providing technical guidance and mentorship to juniors and peers.",
      "Contributed to e2e software design and development by conducting research, creating prototypes, and refining processes and designs."
    ]
  },
  {
    companyName: "Accenture",
    timeLine: "Dec-2021 to Oct-2023",
    designations: ["Specialist", "Senior Analyst"],
    description: [
      "Overseeing the software development lifecycle. Follow best practices in code quality, unit testing, and PR review.",
      "Collaborating with cross-functional teams to design software solutions that match the requirements.",
      "Providing technical support and troubleshooting assistance in a live environment.",
      "Assisting with the design and development of software, including prototypes, research, and design refinement.",
      "Improving debugging abilities to resolve problems.",
    ],
  },
  {
    companyName: "Mindtree",
    timeLine: "Jun-2019 to Nov 2021",
    designations: ["Senior Engineer", "Engineer"],
    description: [
      "Joined the company as a fresher and gained a hand full of experience in the MEAN stack.",
      "Adhering to best practices, Jira, and Git processes, and completing assigned tasks on time.",
      "Delivered features on time and writing clean code and developing generic, reusable components and services.",
      "Climbing the steep learning curve, which includes developing existing skills and learning new ones.",
    ],
  },
];
